module.exports = __webpack_public_path__ + "static/media/productImg5.01ff48f6.png";